module.exports = __webpack_public_path__ + "static/media/bg_about.8a4c66aa.png";